import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import {
  AvailableLookupOsUpdateFeatureKey,
  AvailableLookupOsUpdateReducer,
} from './available-lookup-os-update.reducer';
import { EffectsModule } from '@ngrx/effects';
import { AvailableLookupOsUpdateEffects } from './available-lookup-os-update.effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(AvailableLookupOsUpdateFeatureKey, AvailableLookupOsUpdateReducer),
    EffectsModule.forFeature([AvailableLookupOsUpdateEffects]),
  ],
  providers: [],
})
export class AvailableLookupOsUpdateStoreModule {}
